export default "__VITE_ASSET__hHg7PfXv__"